import { render, staticRenderFns } from "./PerformanceReviewDiscussionItemEditor.vue?vue&type=template&id=9ccc47c6&scoped=true&"
import script from "./PerformanceReviewDiscussionItemEditor.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewDiscussionItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewDiscussionItemEditor.vue?vue&type=style&index=0&id=9ccc47c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccc47c6",
  null
  
)

export default component.exports